export const formatLabel = (label: string, shouldFormat: boolean) => {
  if (!shouldFormat) return { primary: label, secondary: null };

  const colonIndex = label.indexOf(':');
  if (colonIndex === -1) {
    return { primary: label, secondary: null };
  }

  const primary = label.substring(0, colonIndex).trim();
  const secondary = label.substring(colonIndex + 1).trim();

  return { primary, secondary };
};
